import * as RadixSwitch from '@radix-ui/react-switch';
import styles from './Switch.module.css';

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  id?: string;
}

export function Switch({ checked, onChange, label, id }: SwitchProps): React.JSX.Element {
  return (
    <label className={styles.row} htmlFor={id}>
      <span>{label}</span>
      <RadixSwitch.Root id={id} className={styles.root} checked={checked} onCheckedChange={onChange}>
        <RadixSwitch.Thumb className={styles.thumb} />
      </RadixSwitch.Root>
    </label>
  );
}
